<template>
  <div class="inline-block relative w-full cursor-pointer text-gray-600 dark:text-gray-900">
    <FormulateInput
      type="select"
      @input="$emit('input', $event)"
      v-bind="$attrs"
      :input-class="['block appearance-none w-full bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300 rounded-md leading-tight cursor-pointer focus:outline-none focus:shadow-outline', additionalClasses ]"
    />
    <div
      class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-gray-600"
      :class="!subtle ? 'px-4' : 'px-1'"
    >
      <icon-svg icon="fat-arrow-down" class="w-2 h-2" />
    </div>
  </div>
</template>

<script>
import IconSvg from "../IconSvg";

export default {
  name: "BaseSelect",
  inheritAttrs: false,
  props: {
    selected: String,
    subtle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IconSvg,
  },
  computed: {
    additionalClasses () {
      return !this.subtle ? 'py-2 px-4 pr-8 border' : 'py-1 px-2 pr-5 text-sm';
    }
  }
};
</script>
